import { render, staticRenderFns } from "./DatasetFileList.vue?vue&type=template&id=80839e8a&scoped=true&"
import script from "./DatasetFileList.vue?vue&type=script&lang=js&"
export * from "./DatasetFileList.vue?vue&type=script&lang=js&"
import style0 from "./DatasetFileList.vue?vue&type=style&index=0&id=80839e8a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80839e8a",
  null
  
)

export default component.exports